import React, { useState, useEffect, useMemo } from 'react';
import Localize from 'react-intl-universal';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import {
  isOrbis,
  isAok,
  checkHasHomePage,
  checkIsCatalogVisible,
  checkIsSeatsNumber
} from '@common/Util';
import { useGlobalContext } from '@hooks/Context/GlobalContext';
import { routes } from '@navigation/Constants';
import AppRouter from '@navigation/Router';
import './App.css';
import { getByPathAndParams } from '@services/BaseApi';

import de from './locales/de-de.json';
import en from './locales/en-us.json';

const App = () => {
  const language = navigator.language.toLowerCase().includes('de') ? 'de' : 'en';

  const locales = { en, de };
  const [localizeInitDone, setLocalizeInitDone] = useState(false);
  const [publicData, setPublicData] = useState([]);
  const [, setContextData] = useGlobalContext();

  const loadLocales = () => {
    Localize.init({
      currentLocale: language,
      locales
    }).then(() => {
      setLocalizeInitDone(true);
    });
  };

  const hasHomePage = useMemo(() => {
    return checkHasHomePage(publicData);
  }, [publicData]);

  const getPublicPropertiesData = async (path) => {
    try {
      const response = await getByPathAndParams({ path, temApi: true });
      if (response?.data) {
        setPublicData(response.data);
        setContextData((prev) => ({
          ...prev,
          isCatalogVisible: checkIsCatalogVisible(response.data),
          isSeatsNumber: checkIsSeatsNumber(response.data)
        }));
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getPublicPropertiesData(routes.path.publicProperties);
  }, []);

  useEffect(() => {
    loadLocales();
  });

  const renderApp =
    isOrbis() || isAok()
      ? localizeInitDone && publicData && hasHomePage !== undefined
      : localizeInitDone;

  return (
    <>
      {renderApp ? (
        <AppRouter hasHomePage={hasHomePage} />
      ) : (
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh'
          }}
        >
          <CircularProgress />
        </Box>
      )}
    </>
  );
};

export default App;
